import { CommonModule, DatePipe } from '@angular/common';
import { AfterViewInit, Component, ElementRef, HostListener, OnInit, signal, ViewChild, ViewEncapsulation, WritableSignal } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { BreadcrumbComponent } from '@app/lib/components/breadcrumb/breadcrumb.component';
import { IBreadcrumb } from '@app/lib/models/breadcrumb.model';
import { IParty, OtherIdsData } from '../models/party.model';
import { AddPartyDialogComponent } from '../document-reception/add-party-dialog/add-party-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { MatRadioChange, MatRadioModule } from '@angular/material/radio';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule, MatDatepickerToggle } from '@angular/material/datepicker';
import { IResponse } from '@app/lib/models/response.model';
import { TAny } from '@app/lib/models/common.type';
import { DialogMessageComponent } from '../dialog-message/dialog-message.component';
import { PartiesService } from '../services/parties.service';
import { AddressData, AdminType, AliasNameModel, CasPhPrtRolesData, ContactData, CustomContactInfoType, GroupPartyDetails, OtherIdsDataModel, PartyGroupModel, PreviousNameModel } from '../models/partydetails.model';
import { MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { IDType, OtherIdData } from '../models/document-details.model';
import { MatTooltip, MatTooltipModule } from '@angular/material/tooltip';
import { AssignedTaskService } from '../services/assigned-task.service';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { DialogService } from '@app/lib/services/dialog.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ILoginData } from '@app/lib/models/login.model';
import { AuthService } from '@app/auth.service';
import { ConfirmationDialogComponent } from '@app/confirmation-dialog/confirmation-dialog.component';
import { ECourtId } from '@app/dashboard/models/constant';


@Component({
  selector: 'app-parties',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [BreadcrumbComponent, ReactiveFormsModule, FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    MatButtonModule, MatAutocompleteModule, CommonModule, MatProgressSpinnerModule, MatRadioModule, MatDatepickerModule,
    MatNativeDateModule, MatTableModule, MatCheckboxModule, MatDatepickerToggle, MatTooltipModule, ScrollingModule],
  templateUrl: './parties.component.html',
  styleUrls: ['./parties.component.scss'],


})
export class PartiesComponent implements OnInit, AfterViewInit {
  constructor(
    private service: PartiesService,
    private dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    private assignTaskService: AssignedTaskService,
    private dialogService: DialogService,
    private authService: AuthService,

  ) {
    this.partiesData.set(null);
    this.assignTaskService.getTasks();
    this.authService.user
      .pipe(takeUntilDestroyed())
      .subscribe((user => {
        this.userData.set(user);
      }));
  }
  userData: WritableSignal<ILoginData | null> = signal(null);

  public isLoading: WritableSignal<boolean> = signal(false); // Loader State
  public partiesData: WritableSignal<PartyGroupModel | null> = signal(null);
  public getPartiesData: WritableSignal<PartyGroupModel | null> = signal(null);



  public groupParties: WritableSignal<GroupPartyDetails[] | null> = signal(null);
  idTypesList: OtherIdsDataModel[] = [];
  selectedIdcard: OtherIdsDataModel | null = null;
  isEditing: boolean = false
  isEditingIdType = false;
  isadminTypeLoading: boolean = false;

  currentScreenType: boolean = false;
  courtStaffcode: string = '';
  todayDate: Date = new Date();

  @ViewChild(MatTooltip) tooltip!: MatTooltip;
  @ViewChild('emailTooltip') emailTooltip!: MatTooltip;
  @ViewChild('tabContainer') tabContainer!: ElementRef;

  private previousIdTypeId: number | null = null;

  idTypes: IDType[] = [];
  isIDTypeLoading: boolean = false;
  isContactTypeLoading: boolean = false
  previousNamesList: PreviousNameModel[] = [];
  aliasesList: AliasNameModel[] = [];
  partyCasesList: CasPhPrtRolesData[] = [];
  contactsList: ContactData[] = [];
  isAdd: boolean = false;
  isLoadingContacts: boolean = false;
  selectedContactRowForEdit: ContactData | null = null;
  isPreviousNameEditing = false;
  contactTypes: CustomContactInfoType[] = [];
  countryList: AdminType[] = [];
  stateList: AdminType[] = [];
  selectedContact: ContactData | null = null;
  isEditingContact: boolean = false;
  isDashboard: boolean = false;
  showRightArrow = false;
  showLeftArrow = false;
  // For Previous Names
  selectedPreviousNameRow: PreviousNameModel | null = null;
  today: Date = new Date();
  selectedPartyType: string = 'PRS';
  courtIdData: number | null = null;
  isSupremeCourtFlg: boolean = false;
  isCOAFlg: boolean = false;

  public breadcrumbs: WritableSignal<IBreadcrumb[]> = signal([

  ]);


  // For Aliases
  selectedAliasRow: AliasNameModel | null = null;
  isAliasEditing: boolean = false;

  addressList: AddressData[] = []; // List for binding to table
  selectedAddress: AddressData | null = null; // Selected row
  isEditingAddress: boolean = false;
  selectedGroupPartyRows: GroupPartyDetails | null = null;
  responsiveHeight = this.getResponsiveHeight();
  mobileTooltipText = "Not a valid mobile number.<br>Must be in the format<br>0XXX-XXX-XXXX (dashes optional)";
  landlineTooltipText = "Not a valid landline number.<br>Must be in the format<br>0XXX-XXX-XXXX (dashes optional)";
  faxtooltipText = "Not a valid fax number.<br>Must be in the format<br>XXX-XXX-XXXX(dashes<br>optional)";



  selectedTab = 'idCard';
  isEdit: boolean = false;

  ngOnInit(): void {
    this.route.url.subscribe((segments) => {
      const path = segments.map((s) => s.path).join('/');
      this.currentScreenType = path.split('/').pop() == 'court-staff-registration';
      this.resetHandler();
      this.getCourtNameData();
      this.fetchIDTypes();
      this.partyForm.disable();
      this.isEditing = false;

      this.route.queryParams.subscribe(params => {
        const partyId = params['partiesId'];
        if (this.currentScreenType) {
          this.breadcrumbs.set([
            { label: 'Court' },
            { label: 'Court Staff Registration' },
          ]);
          this.selectedPartyType = "CST";
          this.updateValidators('COURTSTAFF');
        }
        this.courtStaffcode = this.userData()?.activeUserId.substring(0, 3).toUpperCase() || '';

        if (!partyId) {
          console.warn('No party Id provided in query params.');
          return;
        } else {
          this.isDashboard = true;
        }

        this.searchFormGrp.reset({
          partyId: partyId
        });
        this.handleSinglePartySearch(partyId, true);
      });
    });
  }
  public searchFormGrp: FormGroup = new FormGroup({
    partyId: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
    partyName: new FormControl(''),
  });
  public searchFormGrp1: FormGroup = new FormGroup({
    partyId: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
    partyName: new FormControl(''),
  });
  public partyForm: FormGroup = new FormGroup({
    partyType: new FormControl(this.currentScreenType ? 'COURTSTAFF' : 'PERSON'),
    staffid: new FormControl('',),
    name: new FormControl('', Validators.required),
    surname: new FormControl('', Validators.required),
    email: new FormControl('', [Validators.email]),
    gender: new FormControl(''),
    idType: new FormControl('', [Validators.required]),
    idNumber: new FormControl('', [Validators.required]),
    education: new FormControl(''),
    occupation: new FormControl(''),
    rank: new FormControl(''),
    nationality: new FormControl(''),
    mobileNumber: new FormControl('', [Validators.pattern(/^\d{11}$/)]),
    father: new FormControl(''),
    mother: new FormControl(''),
    dateOfBirth: new FormControl(''),
    placeOfBirth: new FormControl(''),
    groupName: new FormControl('')
  });

  nameCtrl = this.partyForm.get('name');
  surnameCtrl = this.partyForm.get('surname');
  emailCtrl = this.partyForm.get('email');
  staffidCtrl = this.partyForm.get('staffid');
  groupNameCtrl = this.partyForm.get('groupName');
  mobileCtrl = this.partyForm.get('mobileNumber');
  ngAfterViewInit() {
    // Check initially in case screen is already small
    setTimeout(() => {
      this.checkScroll();
    }, 100);
  }

  // 3. The Logic to toggle arrows
  checkScroll() {
    if (!this.tabContainer?.nativeElement) {
      return;
    }
    const el = this.tabContainer.nativeElement;

    // Tolerance (Math.ceil handles sub-pixel rendering issues on some screens)
    const scrollLeft = Math.ceil(el.scrollLeft);
    const scrollWidth = el.scrollWidth;
    const clientWidth = el.clientWidth;

    // Show Right Arrow if there is more content to the right
    // We add a small buffer (-1) to handle browser calculation differences
    this.showRightArrow = (scrollLeft + clientWidth) < (scrollWidth - 1);

    // Optional: Show Left Arrow if we are not at the start
    this.showLeftArrow = scrollLeft > 0;
  }

  // 4. Function to scroll when arrow is clicked
  scrollTabs(direction: 'left' | 'right') {
    if (!this.tabContainer?.nativeElement) return;
    const el = this.tabContainer.nativeElement;
    const scrollAmount = 200; // How many pixels to scroll

    if (direction === 'right') {
      el.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    } else {
      el.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    }

    // Re-check visibility after scroll finishes (approx 300ms)
    setTimeout(() => this.checkScroll(), 350);
  }
  public personFields = [
    { label: 'Name', name: 'name' },
    { label: 'Surname', name: 'surname' },
    { label: 'E-Mail ID', name: 'email', type: 'email', },
    { label: 'Gender', name: 'gender' },
    { label: 'ID Type', name: 'idType' },
    { label: 'ID number', name: 'idNumber' },
    { label: 'Education', name: 'education' },
    { label: 'Rank', name: 'rank' },
    { label: 'Occupation', name: 'occupation' },
    { label: 'Nationality', name: 'nationality' },
    { label: 'Mobile Number', name: 'mobileNumber', type: 'tel' },
    { label: 'Father', name: 'father' },
    { label: 'Mother', name: 'mother' },
    { label: 'Date of Birth', name: 'dateOfBirth', type: 'date' },
    { label: 'Place of Birth', name: 'placeOfBirth' },
  ];
  get filteredPersonFields() {
    return this.personFields.filter(field => {
      if (this.currentScreenType) {
        // true → hide occupation
        return field.name !== 'occupation';
      } else {
        // false → hide rank
        return field.name !== 'rank';
      }
    });
  }

  @HostListener('window:resize')
  onResize() {
    this.responsiveHeight = this.getResponsiveHeight();
  }


  public searchHandler(section?: string, isGroup?: boolean): void {
    const searchKey = section === 'party-Id' ? 'partyId' : 'partyName';
    const searchQuery = isGroup
      ? this.searchFormGrp1.get(searchKey)?.value
      : this.searchFormGrp.get(searchKey)?.value;

    const dialogRef = this.dialog.open(AddPartyDialogComponent, {
      data: {
        section,
        searchQuery,
        multi: this.selectedPartyType === "GRP",
        isCourtStaff: this.currentScreenType
      }, disableClose: true,           // Prevents closing on outside click or ESC
      hasBackdrop: true,            // Shows backdrop to block interaction
      backdropClass: 'dialog-backdrop', // Optional: custom styling
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.isLoading.set(true);
        isGroup
          ? this.handleGroupPartySearch(result)
          : this.handleSinglePartySearch(result.partiesId);
      } else {
        this.isLoading.set(false);
      }


    });
  }
  getCourtNameData(): ILoginData | null {
    try {
      const userData = localStorage.getItem('userData') as string;
      const userData2 = userData ? JSON.parse(userData) : null;
      this.courtIdData = userData2.courtId;
      if (this.courtIdData && this.courtIdData === ECourtId.SC_ID) {
        this.breadcrumbs.set([{ label: 'Appeal' },
        { label: 'Parties' }])
        this.isSupremeCourtFlg = true;
      } else if (this.courtIdData && this.courtIdData === ECourtId.COA_ID) {
        this.isCOAFlg = true;
      } else {
        this.breadcrumbs.set([{ label: 'Case' },
        { label: 'Parties' }])
      }
      return userData ? JSON.parse(userData) : null;
    } catch (err) {
      return null
    }

  }

  private handleGroupPartySearch(result: IParty[] | IParty): void {
    const partyList: IParty[] = Array.isArray(result) ? result : [result]; // 🔁 Normalize

    const mappedGroupParties: GroupPartyDetails[] = partyList.map((party: IParty) => ({
      prtType: party.prtType,
      partiesId: party.partiesId,
      partiesFullName: party.partiesFullName,
      groupId: null,
      groupHeadStatus: 'N',
      partyStatus: '',
      gridRemarks: '',
      transType: "I",
      auditMessage: '',
      checked: true
    }));

    this.groupParties.update(prev => [...(prev ?? []), ...mappedGroupParties]);
    this.isLoading.set(false);
  }

  private handleSinglePartySearch(result: String, isDash: boolean = false): void {
    this.partyForm.disable();
    const reqBody = { partiesName: '', partiesId: result, partiesFullName: '' };

    this.resetHandler();
    this.resetSelectionStates();
    this.isDashboard = isDash;
    this.isEditing = false;
    this.partyForm.disable();

    this.service.searchParties(reqBody).subscribe({
      next: (res: IResponse<PartyGroupModel>) => {
        this.isLoading.set(false);
        if (res?.data) {
          this.isAdd = false;
          this.resetPartyFormValues(res.data);
          this.selectedTab = res.data.prtType === 'GRP' ? 'cases' : 'idCard';
        } else {
          this.showDialog('Information', "No Privilege to access the data (or) No Data Exists", 'info');
        }
      },
      error: () => {
        this.isLoading.set(false);
        this.showDialog('Information', "No Privilege to access the data (or) No Data Exists", 'info');
      }
    });
  }

  isRequired(fieldName: string): boolean {
    const control = this.partyForm.get(fieldName);
    if (!control) return false;

    const validator = control.validator?.({} as any);
    return validator && validator['required'];
  }
  private resetSelectionStates(): void {
    this.isAdd = false;
    this.isEditing = false;
    this.selectedIdcard = null;
    this.selectedAliasRow = null;
    this.selectedPreviousNameRow = null;
    this.selectedTab = 'idCard';
    this.selectedGroupPartyRows = null;

  }

  getResponsiveHeight(): string {
    const screenHeight = window.innerHeight;
    if (screenHeight < 600) {
      return '25px';
    } else if (screenHeight < 900) {
      return '30px';
    } else {
      return '40px';
    }
  }

  addIdTypeRow(): void {
    const newRow: OtherIdsDataModel = {
      prtId: null,
      validUntil: null,
      rowId: null,
      transType: this.isAdd ? "I" : "U",
      istId: null,
      istName: '',
      istValue: '',
      activeFlag: null,
      auditMessage: '',
      isNew: true,
      isLoadingIdTypes: false
    };



    // Optionally preload dropdown options
    if (this.idTypes.length === 0) {
      newRow.isLoadingIdTypes = true;
      this.service.getIDTypes().subscribe({
        next: (response) => {
          this.idTypes = response.success;
          newRow.isLoadingIdTypes = false;
        },
        error: (error) => {
          console.error('Error fetching ID Types:', error);
          newRow.isLoadingIdTypes = false;
        }
      });
    }

    // Push and refresh table (deep clone array to trigger change detection)
    this.selectedIdcard = newRow;
    this.idTypesList = [...this.idTypesList, newRow];
    this.isEditingIdType = true;
  }

  getPlaceholder(contactType: string): string {
    switch (contactType) {
      case 'EMAIL': return 'Enter email';
      case 'MOBILE': return 'Enter mobile number';
      case 'LANDLINE PHONE': return 'Enter landline number';
      case 'FAX': return 'Enter fax number';
      default: return 'Enter contact details';
    }
  }

  getTooltip(element: any): string {
    switch (element.contactInfoTypesName) {

      case 'EMAIL': return 'This field should be an email address in the format "user@example.com"';
      case 'MOBILE': return 'Not a valid mobile number.<br>Must be in the format<br>0XXX-XXX-XXXX (dashes optional)';
      case 'LANDLINE PHONE': return 'Not a valid landline number.<br>Must be in the format<br>0XXX-XXX-XXXX (dashes optional)';
      case 'FAX': return 'Not a valid fax number.<br>Must be in the format<br>XXX-XXX-XXXX(dashes<br>optional)';
      default: return 'Enter valid contact details';
    }
  }

  isValidContact(element: any): boolean {
    switch (element.contactInfoTypesName) {
      case 'EMAIL': return this.isValidEmail(element.contactData);
      case 'MOBILE':
      case 'LANDLINE PHONE':
      case 'FAX': return this.isValidMobileNumber(element.contactData);
      default: return true;
    }
  }
  onGroupHeadChange(selectedPartyId: string, selectedValue: 'Y' | 'N'): void {
    const currentGroup = this.groupParties();

    if (currentGroup && Array.isArray(currentGroup)) {
      const updated: GroupPartyDetails[] = currentGroup.map(party => {
        if (party.partiesId === selectedPartyId) {
          return { ...party, groupHeadStatus: selectedValue };
        } else if (selectedValue === 'Y') {
          return { ...party, groupHeadStatus: 'N' as const };
        }
        return party;
      });

      this.groupParties.set(updated);
    }
  }



  addPreviousName(): void {
    const newRow: PreviousNameModel = {
      partiesId: !this.isAdd ? this.partiesData()?.partiesId : "",
      name: '',
      familyName: '',
      validUntil: '',
      rowId: null,
      transType: null,
      auditMessage: '',
      isNew: true
    };

    this.selectedPreviousNameRow = newRow;
    this.previousNamesList = [...this.previousNamesList, newRow];
    this.isPreviousNameEditing = true;
  }
  // For Previous Names
  onPreviousNameCheckboxChange(row: PreviousNameModel, checked: boolean): void {
    if (checked) {
      this.selectedPreviousNameRow = row;
      this.isPreviousNameEditing = false
    } else {
      this.selectedPreviousNameRow = null;
      this.isPreviousNameEditing = false
    }
  }

  // For Aliases
  onAliasCheckboxChange(row: AliasNameModel, checked: boolean): void {
    if (checked) {
      this.selectedAliasRow = row;
      this.isAliasEditing = false;
    } else {
      this.selectedAliasRow = null;
      this.isAliasEditing = false;
    }
  }

  onPreviousNameModifyClick(): void {
    if (this.selectedPreviousNameRow) {
      this.selectedPreviousNameRow.isEdited = true;
      this.isPreviousNameEditing = true;
    }
  }

  onAliasModifyClick(): void {
    if (this.selectedAliasRow) {
      this.selectedAliasRow.isEdited = true;
      this.isAliasEditing = true;
    }
  }

  modifySelectedIdCard() {
    this.isIDTypeLoading = true;
    if (this.idTypes.length > 0) {
      this.isIDTypeLoading = false;
    } else {
      this.service.getIDTypes().subscribe({
        next: (response) => {
          this.idTypes = response.success;
          this.isIDTypeLoading = false;
        },
        error: (error) => {
          console.error('Error fetching ID Types:', error);
          this.isIDTypeLoading = false;
        }
      });
    }

    if (this.selectedIdcard) {
      this.isEditingIdType = true;
      this.selectedIdcard.isEdited = true;
    }
  }
  onIdCardCancelClick(): void {
    if (this.selectedIdcard) {
      this.selectedIdcard.isEdited = false;
      this.isEditingIdType = false;
    }
    this.selectedIdcard = null
    this.idTypesList = this.getPartiesData()?.otherIdsData ?? [];
  }
  onIdTypeSelected(element: OtherIdsDataModel) {
    const selectedType = this.idTypes.find(type => type.id === element.istId);
    if (selectedType) {
      element.istName = selectedType.name;

      if (selectedType.name?.toLowerCase().includes('unknown')) {
        element.istValue = this.generateUniqueIdNumber();
        element.disableIdInput = true;
      } else {
        element.istValue = '';
        element.disableIdInput = false;
      }
    }
  }
  oncontactTypeSelected(element: ContactData) {
    const selectedType = this.contactTypes.find(type => type.id === element.contactInfoTypesId);
    if (selectedType) {
      element.contactInfoTypesName = selectedType.name;
    }
  }
  generateUniqueIdNumber(): string {
    const name = this.partyForm.get('name')?.value || '';
    const surname = this.partyForm.get('surname')?.value || '';
    const namePart = name.substring(0, 5).toUpperCase();
    const surnamePart = surname.substring(0, 5).toUpperCase();
    const timestamp = Date.now();

    return `${namePart}${surnamePart}${timestamp}`;
  }

  onIdFieldChange(index: number) {
    if (this.idTypesList[index]) {
      this.idTypesList[index].isEdited = true;
    }
  }
  onPreviousNameCancelClick(): void {
    if (this.selectedPreviousNameRow) {
      this.selectedPreviousNameRow.isEdited = false;
      this.isPreviousNameEditing = false;
    }
    this.selectedPreviousNameRow = null
    this.previousNamesList = this.getPartiesData()?.previousNamesData ?? [];
  }
  onAliasNameCancelClick(): void {
    if (this.selectedAliasRow) {
      this.selectedAliasRow.isEdited = false;
      this.isAliasEditing = false;
    }
    this.selectedAliasRow = null
    this.aliasesList = this.getPartiesData()?.aliasesData ?? [];
  }
  addAlias(): void {
    const newRow: AliasNameModel = {
      partiesId: !this.isAdd ? this.partiesData()?.partiesId : "",
      aliasName: '',
      rowId: null,
      transType: 'I',
      auditMessage: '',
      isNew: true,
    };

    this.selectedAliasRow = newRow;
    this.aliasesList = [...this.aliasesList, newRow];
    this.isAliasEditing = true;
  }

  addContactRow(): void {
    this.fetchContactTypes();
    const newContact: ContactData = {
      partiesId: !this.isAdd ? this.partiesData()?.partiesId : "",
      contactInfoTypesId: 0,
      contactInfoTypesName: '',
      seq: null,  // auto-increment seq
      citId: null,
      contactData: '',
      validForm: null,
      validUntil: null,
      ctcComment: '',
      currentContact: 'N',
      transType: "I",  // new entry
      auditMessage: '',
      isNew: true,
    };

    this.contactsList = [...this.contactsList, newContact];
    this.isEditingContact = true;
    this.selectedContact = newContact;


  }

  onContactFieldChange(index: number): void {
    if (this.contactsList[index]) {
      this.contactsList[index].isEdited = true;
    }
  }
  onContactCheckboxChange(element: ContactData, isChecked: boolean): void {
    if (isChecked) {
      this.selectedContact = element;
    } else {
      this.selectedContact = null;
      this.isEditingContact = false;
    }
  }

  onModifyContactClick(): void {
    this.fetchContactTypes();
    if (this.selectedContact) {
      this.selectedContact.isEdited = true;
      this.isEditingContact = true;
    }
  }
  onCancelContactClick(): void {
    if (this.selectedContact) {
      this.selectedContact.isEdited = false;
      this.isEditingContact = false;
    }
    this.selectedContact = null
    this.contactsList = this.getPartiesData()?.contactsData ?? [];
  }
  onContactTypeChange(element: ContactData, selectedId: number) {
    const selectedType = this.contactTypes.find(type => type.id === selectedId);
    if (selectedType) {
      element.contactInfoTypesId = selectedType.id;
      element.contactInfoTypesName = selectedType.name;
    }
  }


  onidCardCheckboxChange(element: any, isChecked: boolean): void {
    this.selectedIdcard = null
    if (isChecked && element.isNew) {
      element.isIDTypeLoading = true;

      if (this.idTypes.length > 0) {
        element.isIDTypeLoading = false;
      } else {
        this.service.getIDTypes().subscribe({
          next: (response) => {
            this.idTypes = response.success;
            element.isIDTypeLoading = false;
          },
          error: (error) => {
            console.error('Error fetching ID Types:', error);
            element.isIDTypeLoading = false;
          }
        });
      }
    }

    if (isChecked) {
      this.selectedIdcard = element;
      this.isEditingIdType = false; // Reset editing mode until Modify clicked
    } else {
      this.selectedIdcard = null;
    }
  }

  addAddressRow(): void {
    this.fetchCountry();
    this.fetchState();
    const newAddress: AddressData = {
      partiesId: !this.isAdd ? this.partiesData()?.partiesId : "",
      seq: null,
      currentMailTo: 'N',
      subsidaryDescription: '',
      street: '',
      streetNo: '',
      adminUnitsByAmuIdCountry: '',
      adminUnitsByAmuIdCountryId: 0,
      adminUnitsByAmuIdPlace: '',
      adminUnitsByAmuIdPlaceId: 0,
      validForm: null,
      validUntil: null,
      adrComment: '',
      transType: 'I',
      auditMessage: '',
      isNew: true
    };
    this.addressList = [...this.addressList, newAddress];
    this.isEditingAddress = true;
    this.selectedAddress = newAddress;
  }

  onAddressCheckboxChange(row: AddressData, checked: boolean): void {
    if (checked) {
      this.selectedAddress = row;
      this.isEditingAddress = false;
    } else {
      this.selectedAddress = null;
      this.isEditingAddress = false;
    }
  }

  onCountrySelected(row: any, selectedCountryId: number) {
    const selectedCountry = this.countryList.find(c => c.id === selectedCountryId);
    if (selectedCountry) {
      row.adminUnitsByAmuIdCountry = selectedCountry.name;
    }
  }

  onStateSelected(row: any, selectedStateId: number) {
    const selectedState = this.stateList.find(s => s.id === selectedStateId);
    if (selectedState) {
      row.adminUnitsByAmuIdPlace = selectedState.name;
    }
  }

  toDateInputFormat(date: any): string | null {
    if (!date) return null;

    const d = new Date(date);
    const year = d.getFullYear();
    const month = ('0' + (d.getMonth() + 1)).slice(-2);
    const day = ('0' + d.getDate()).slice(-2);
    return `${year}-${month}-${day}`;
  }

  onModifyAddressClick(): void {
    this.fetchCountry();
    this.fetchState();
    if (this.selectedAddress) {
      this.selectedAddress.isEdited = true;
      this.isEditingAddress = true;
    }
  }
  onCancelAddressClick(): void {
    if (this.selectedAddress) {
      this.selectedAddress.isEdited = false;
      this.isEditingAddress = false;
    }
    this.selectedAddress = null;
    this.addressList = this.getPartiesData()?.addressesData ?? [];
  }

  resetPartyFormValues(data: PartyGroupModel): void {
    this.fetchIDTypes();
    this.getPartiesData.set(data);
    this.partiesData.set(data);
    this.groupParties.set(data.groupPartyDetails);
    this.idTypesList = [...data.otherIdsData];
    this.contactsList = data.contactsData;
    this.previousNamesList = data.previousNamesData;
    this.aliasesList = data.aliasesData;
    this.partyCasesList = data.casPhPrtRolesData;
    const party = this.partiesData();
    this.addressList = data.addressesData;
    const primaryIdRecord = party?.otherIdsData?.[0];


    const partyTypeLabel = this.getPartyTypeLabel(data?.prtType);
    this.partyForm.reset({
      partyType: partyTypeLabel,
      staffid: (party?.prtType === 'CST' || this.currentScreenType) ? party?.partiesId : '',
      name: party?.partiesName ?? '',
      surname: party?.familyName ?? '',
      email: party?.emailId ?? '',
      gender: party?.gender ?? '',
      education: party?.education ?? '',
      occupation: party?.occupation ?? '',
      nationality: party?.nationality ?? '',
      mobileNumber: party?.mobileNumber ?? '',
      father: party?.father ?? '',
      mother: party?.mother ?? '',
      dateOfBirth: party?.dateOfBirth ?? '',
      placeOfBirth: party?.placeOfBirth ?? '',
      groupName: party?.partiesName ?? '',
      idType: primaryIdRecord ? (this.idTypes?.find(opt => opt.id === primaryIdRecord.istId) ?? null) : null,
      idNumber: primaryIdRecord?.istValue ?? ''

    });

    this.updateValidators(partyTypeLabel);
  }

  handleIdTypeChange(selectedOption: any): void {
    if (!selectedOption) return;

    const idNumberControl = this.partyForm.get('idNumber');
    if (!idNumberControl) return;

    // Extract selected type (works whether selectedOption is an object or an ID)
    const selectedType = typeof selectedOption === 'object'
      ? selectedOption
      : this.idTypes.find(t => t.id === selectedOption);

    const isUnknown = selectedType?.name?.toLowerCase().includes('unknown');

    if (isUnknown) {
      // 1. Disable input field
      idNumberControl.disable();

      // 2. Check if an Unknown ID already exists in idTypesList
      const existingUnknown = this.idTypesList.find(item =>
        item.istId === selectedType?.id || item.istName?.toLowerCase().includes('unknown')
      );

      // 3. Reuse existing ID if available; otherwise generate a new one
      if (existingUnknown && existingUnknown.istValue) {
        idNumberControl.patchValue(existingUnknown.istValue);
      } else if (!idNumberControl.value) {
        idNumberControl.patchValue(this.generateUniqueIdNumber());
      }
    } else {
      // Enable field for normal ID types
      idNumberControl.enable();

      // Clear value if switching away from an auto-generated Unknown ID
      const isAutoGenerated = this.idTypesList.some(item => item.istValue === idNumberControl.value);
      if (isAutoGenerated) {
        idNumberControl.patchValue('');
      }
    }

    idNumberControl.updateValueAndValidity();
  }

  onPartyTypeChange(event: MatRadioChange): void {
    const selectedValue = event.value;
    this.isEditing = false;
    this.selectedIdcard = null;
    this.selectedAliasRow = null;
    this.selectedPreviousNameRow = null;
    this.selectedTab = 'idCard';
    this.selectedGroupPartyRows = null;
    this.contactsList = [];
    this.idTypesList = [];
    this.addressList = [];

    this.isEditingIdType = false;
    this.isEditingAddress = false;
    this.isEditingContact = false;
    this.isPreviousNameEditing = false;
    this.isAliasEditing = false;

    this.partyForm.reset({
      partyType: selectedValue,
      name: '', surname: '', email: '', gender: '', education: '',
      occupation: '', nationality: '', mobileNumber: '',
      father: '', mother: '', dateOfBirth: '', placeOfBirth: '', groupName: ''
    });

    this.updateValidators(selectedValue);
  }

  compareGender(a: string, b: string): boolean {
    return a?.toLowerCase() === b?.toLowerCase();
  }

  private updateValidators(partyType: string): void {
    const config: { [key: string]: { required?: string[], clear?: string[], selectedType: string } } = {
      'PERSON': { required: ['name', 'surname', 'idType', 'idNumber'], clear: ['email', 'groupName', 'staffid'], selectedType: 'PRS' },
      'CORPORATE': { required: ['name', 'idType', 'idNumber'], clear: ['surname', 'email', 'staffid', 'groupName'], selectedType: 'CRE' },
      'GROUP': { required: ['groupName'], clear: ['name', 'surname', 'email', 'staffid', 'idType', 'idNumber'], selectedType: 'GRP' },
      'GOVT': { required: ['name', 'idType', 'idNumber'], clear: ['surname', 'email', 'staffid', 'groupName'], selectedType: 'GOVT' },
      'COURTSTAFF': { required: ['name', 'surname', 'email', 'staffid'], clear: ['groupName'], selectedType: 'CST' }
    };

    const settings = config[partyType];
    if (settings) {
      settings.required?.forEach(field => {
        const control = this.partyForm.get(field);
        if (control) {
          // If the field is staffid, bundle required + maxLength + pattern together
          if (field === 'staffid') {
            control.setValidators([
              Validators.required,
              Validators.maxLength(8),
              Validators.pattern(/^\d+$/)
            ]);
          } else if (field === 'email') {
            control.setValidators([Validators.required, Validators.email]);
          } else {
            control.setValidators([Validators.required]);
          }
        }
      });
      settings.clear?.forEach(field => {
        const control = this.partyForm.get(field);
        if (control) {
          control.clearValidators();

          // If we clear staffid from being required, still keep its structural length check safe
          if (field === 'staffid') {
            control.setValidators([Validators.maxLength(8), Validators.pattern(/^\d+$/)]);
          }
        }
      });
      this.selectedPartyType = settings.selectedType;
    }

    Object.keys(this.partyForm.controls).forEach(key => this.partyForm.get(key)?.updateValueAndValidity());
  }
  private getPartyTypeLabel(prtType: string | undefined): string {
    switch (prtType) {
      case 'PRS': return 'PERSON';
      case 'GRP': return 'GROUP';
      case 'GOVT': return 'GOVT';
      case 'CST': return 'COURTSTAFF'
      default: return 'CORPORATE';
    }
  }
  onSingleCheckboxChange(selectedId: GroupPartyDetails, checked: boolean): void {
    if (checked) {
      this.selectedGroupPartyRows = selectedId;
    }
    else {
      this.selectedGroupPartyRows = null
    }
  }
  inactivateSelected(): void {
    if (!this.selectedGroupPartyRows?.gridRemarks?.trim()) {
      this.showDialog('Validation Error', 'Remarks are required to inactivate the selected party.', 'warning');
      return;
    }
    if (this.selectedGroupPartyRows?.groupHeadStatus !== 'N') {
      this.showDialog('Validation Error', 'Unable to inactivate group Head', 'warning');
      return;
    }

    const reqBody = [{
      prtType: '',
      partiesId: this.selectedGroupPartyRows.partiesId,
      partiesFullName: this.selectedGroupPartyRows.partiesFullName,
      groupParentId: "",
      groupHeadStatus: this.selectedGroupPartyRows.groupHeadStatus,
      partyStatus: this.selectedGroupPartyRows.partyStatus,
      gridRemarks: this.selectedGroupPartyRows.gridRemarks,
      transType: "",
      groupId: this.partiesData()?.partiesId,
      groupName: this.partiesData()?.partiesName
    }];

    this.service.inactivateGroupParties(reqBody).subscribe({
      next: (res: IResponse<TAny> | null) => {
        if (res?.success) {
          this.showDialog('Success', res.message || 'Party inactivated successfully', 'check_small');
          this.searchFormGrp.get('partyId')?.setValue(this.partiesData()?.partiesId);
          this.handleSinglePartySearch(this.partiesData()?.partiesId ?? '', false);
          this.finalizeSave();
        } else {
          this.showDialog('Information', res?.message || 'Failed to inactivate party', 'info');
        }
      },
      error: (err: any) => {
        console.error('Error inactivate party:', err);
        this.showDialog('Error', 'An error occurred while inactivating party', 'error');
      },
    });
  }

  resetHandler(): void {
    this.searchFormGrp.reset({
      partyId: '',
      partyName: ''
    })
    this.partyForm.reset({
      partyType: this.currentScreenType ? 'COURTSTAFF' : 'PERSON', // default value
      name: '',
      surname: '',
      email: '',
      gender: '',
      education: '',
      occupation: '',
      nationality: '',
      mobileNumber: '',
      father: '',
      mother: '',
      dateOfBirth: '',
      placeOfBirth: '',
      groupName: ''
    });
    this.partiesData.set(null);
    this.getPartiesData.set(null);
    this.idTypesList = [];
    this.contactsList = [];
    this.previousNamesList = [];
    this.aliasesList = [];
    this.partyCasesList = [];
    this.isAdd = false;
    this.isEditing = false;
    this.selectedIdcard = null;
    this.selectedAliasRow = null;
    this.selectedPreviousNameRow = null;
    this.selectedTab = 'idCard';
    this.selectedGroupPartyRows = null;
    this.isPreviousNameEditing = false;
    this.selectedContact = null;
    this.isEditingContact = false;
    this.selectedAddress = null;
    this.isEditingAddress = false;
    this.isEditingIdType = false;
    this.isDashboard = false;
    this.groupParties.set([]);

    this.updateValidators("PERSON")


  }
  onPrint(): void {

  }

  get gridClass() {
    return this.selectedPartyType === 'GRP'
      ? 'grid grid-cols-1 gap-x-4 gap-y-0'
      : '';
  }
  handleSave(): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: 'Confirm Action',
        message: "Are you sure you want to save?",
      }, disableClose: true,
      hasBackdrop: true,
      backdropClass: 'dialog-backdrop',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this._onsave();
      }
    });
  }
  cleanObject(obj: any): any {
    const keysToRemove = [
      'activeFlag',
      'auditMessage',
      'isNew',
      'isLoadingIdTypes',
      'disableIdInput',
      'isEdited'
    ];

    if (Array.isArray(obj)) {
      return obj.map(item => this.cleanObject(item));
    }

    if (obj !== null && typeof obj === 'object') {
      return Object.keys(obj).reduce((acc: any, key) => {

        // ❌ Remove unwanted keys
        if (keysToRemove.includes(key)) return acc;

        // ❌ Remove extra keys when currentScreenType is true
        if (this.currentScreenType && ['groupSearchPartyId', 'groupSearchPartyName', 'groupPartyId', 'groupPartyName', 'groupPartyDetails'].includes(key)) return acc;

        acc[key] = this.cleanObject(obj[key]); // 🔁 recursion
        return acc;

      }, {});
    }

    return obj;
  }

  private _onsave(): void {
    if (!this.validateMainForm()) return;

    const reqBody = this.prepareRequestPayload();
    const body = this.currentScreenType
      ? { ...reqBody, isCourtStaff: 'Y', courtStaffCode: this.courtStaffcode }
      : reqBody;

    const finalBody = this.cleanObject(body);


    this.service.saveParties(finalBody).subscribe({
      next: (res: IResponse<TAny> | null) => {
        if (res?.success) {
          this.showDialog('Success', res.message || 'Saved successfully', 'check_small');
          if (res.partyId) {
            this.searchFormGrp.get('partyId')?.setValue(res.partyId);
            this.handleSinglePartySearch(res.partyId, false);
          }
          this.finalizeSave();
        } else {
          this.showDialog('Information', res?.message || 'Failed to save', 'info');
        }
      },
      error: (err: any) => {
        console.error('Error saving party:', err);
        this.showDialog('Error', 'An error occurred while saving', 'error');
      },
    });
  }

  private validateMainForm(): boolean {
    const form = this.partyForm;
    if (form.invalid) {
      form.markAllAsTouched();
      Object.keys(form.controls).forEach(field => {
        const control = form.get(field);
        if (control?.invalid) {
          console.log('Invalid field:', field, control.errors);
        }
      });
      this.showDialog('Info', 'Please enter the mandatory fields', 'info');
      return false;
    }

    // if ((this.idTypesList.length === 0) && this.selectedPartyType !== 'GRP') {
    //   this.showDialog('Info', 'In ID Card(s), at least one ID Card entry is mandatory', 'info');
    //   return false;
    // }

    // Sub-table Validations
    if (this.idTypesList.some(id => (id.isNew || id.isEdited) && (!id.istId || !id.istValue?.trim()))) {
      this.showDialog('Validation Error', 'Please complete all ID Card entries.', 'info');
      return false;
    }

    if (this.contactsList.some(c => (c.isNew || c.isEdited) && (!c.contactInfoTypesId || !c.contactData?.trim()))) {
      this.showDialog('Validation Error', 'Please complete all Contact entries.', 'info');
      return false;
    }

    if (this.addressList.some(a => (a.isNew || a.isEdited) && (!a.adminUnitsByAmuIdCountryId || !a.adminUnitsByAmuIdPlaceId))) {
      this.showDialog('Validation Error', 'Please complete all Address entries (Country and State are mandatory).', 'info');
      return false;
    }

    if (this.previousNamesList.some(p => (p.isNew || p.isEdited) && (!p.name?.trim() || !p.familyName?.trim() || !p.validUntil))) {
      this.showDialog('Validation Error', 'Please complete all Previous Name entries.', 'info');
      return false;
    }

    // Future date validation for Previous Names validUntil
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (this.previousNamesList.some(p => (p.isNew || p.isEdited) && p.validUntil && new Date(p.validUntil) <= today)) {
      this.showDialog('Validation Error', 'Valid Until date for previous names must be in the future.', 'info');
      return false;
    }

    if (this.aliasesList.some(al => (al.isNew || al.isEdited) && !al.aliasName?.trim())) {
      this.showDialog('Validation Error', 'Please complete all Alias entries.', 'info');
      return false;
    }

    if (this.selectedPartyType === 'GRP') {
      const groupList = this.groupParties() || [];
      if (groupList.length === 0) {
        this.showDialog('Group Party Validation', 'At least one group party must be added for group type.', 'info');
        return false;
      }
      if (!groupList.some(party => party.groupHeadStatus === 'Y')) {
        this.showDialog('Group Head Required', 'At least one group party must be marked as Group Head.', 'info');
        return false;
      }
    }

    return true;
  }

  private prepareRequestPayload(): any {
    const form = this.partyForm;
    const rawStaffId = form.get('staffid')?.value;
    const paddedStaffId = rawStaffId ? rawStaffId.toString().padStart(5, '0') : '';
    const idTypeValue = form.get('idType')?.value;
    if (this.isAdd) {
      this.idTypesList = this.idTypesList = [
        {
          prtId: '',
          istName: idTypeValue?.name ?? '', // Provide default string or null
          istId: idTypeValue?.id ?? null,
          validUntil: null,
          transType: 'I', // Added quotes
          rowId: null, // Provide default value or null
          istValue: form.get('idNumber')?.value, // Added quotes
          partiesId: '', // Assigned variable or empty string/null
          auditMessage: '', // Required by OtherIdsDataModel interface
          activeFlag: true,
          isNew: true,
          isEdited: false
        }
      ] as OtherIdsDataModel[];
    }

    // 2. Assign the padded version to partiesId during an 'Add' action
    const partiesId = this.isAdd
      ? (this.currentScreenType ? paddedStaffId : '')
      : this.partiesData()?.partiesId;
    return {
      prtType: this.selectedPartyType,
      partiesId: partiesId,
      partiesName: this.selectedPartyType === 'GRP' ? form.get('groupName')?.value || '' : form.get('name')?.value || '',
      familyName: form.get('surname')?.value || '',
      partiesFullName: this.selectedPartyType === 'GRP' ? form.get('groupName')?.value || '' : `${form.get('name')?.value || ''} ${form.get('surname')?.value || ''}`.trim(),
      groupPartyId: this.selectedPartyType === 'GRP' ? this.partiesData()?.partiesId : "",
      groupPartyName: this.selectedPartyType === 'GRP' ? form.get('groupName')?.value || '' : "",
      emailId: form.get('email')?.value || '',
      externalId: '',
      gender: form.get('gender')?.value || '',
      education: form.get('education')?.value || '',
      occupation: this.currentScreenType ? form.get('rank')?.value : (form.get('occupation')?.value || ''),
      nationality: form.get('nationality')?.value || '',
      mobileNumber: form.get('mobileNumber')?.value || '',
      father: form.get('father')?.value || '',
      mother: form.get('mother')?.value || '',
      dateOfBirth: form.get('dateOfBirth')?.value || '',
      placeOfBirth: form.get('placeOfBirth')?.value || '',
      religion: '',
      groupSearchPartyId: this.isAdd && this.selectedPartyType === 'GRP' ? this.searchFormGrp1.get('partyId')?.value : "",
      groupSearchPartyName: this.isAdd && this.selectedPartyType === 'GRP' ? this.searchFormGrp1.get('partyName')?.value : "",
      transType: this.isAdd ? "I" : "U",

      addressesData: this.selectedPartyType === 'GRP' ? [] : this.addressList.filter(r => r.isNew || r.isEdited).map(item => ({
        ...item,
        partiesId,
        transType: item.isNew ? "I" : "U",
        currentMailTo: item.currentMailTo === 'D'
      })),

      contactsData: this.selectedPartyType === 'GRP' ? [] : this.contactsList.filter(r => r.isNew || r.isEdited).map(item => ({
        ...item,
        partiesId,
        transType: item.isNew ? "I" : "U"
      })),

      previousNamesData: this.selectedPartyType === 'GRP' ? [] : this.previousNamesList.filter(r => r.isNew || r.isEdited).map(item => ({
        ...item,
        partiesId,
        transType: item.isNew ? "I" : "U"
      })),

      aliasesData: this.selectedPartyType === 'GRP' ? [] : this.aliasesList.filter(r => r.isNew || r.isEdited).map(item => ({
        ...item,
        partiesId,
        transType: item.isNew ? "I" : "U"
      })),

      otherIdsData: this.selectedPartyType === 'GRP' ? [] : this.idTypesList.filter(r => r.isNew || r.isEdited).map(item => ({
        ...item,
        partiesId,
        transType: item.isNew ? "I" : "U"
      })),

      groupPartyDetails: this.groupParties() || []
    };
  }

  private finalizeSave(): void {
    this.isEditing = false;
    this.isAdd = false;
    this.partiesData.set(this.getPartiesData());
    this.partyForm.disable();
    this.resetSelectionStates();
  }

  private showDialog(title: string, message: string, icon: string): void {
    this.dialogService.openDialog1({
      data: { title, message, icon },
      disableClose: true,
      hasBackdrop: true,
      backdropClass: 'dialog-backdrop',
    });
  }

  toggleEdit(): void {
    this.isEditing = true;
    this.fetchIDTypes();
    this.partyForm.enable();
    if (!this.isAdd) {
      this.partyForm.get('partyType')?.disable();
      this.partyForm.get('idType')?.disable();
      this.partyForm.get('idNumber')?.disable();
    }


  }
  toggleAdd(): void {
    this.isAdd = true;
    this.partyForm.enable();
    this.isEditing = false;
    this.selectedIdcard = null;
    this.selectedAliasRow = null;
    this.selectedPreviousNameRow = null;
    this.selectedTab = 'idCard';
    this.selectedGroupPartyRows = null;
    this.fetchIDTypes();
  }
  cancelEdit(): void {
    this.isEditing = false;
    this.isAdd = false;
    this.isEditingIdType = false;
    this.isEditingAddress = false;
    this.isEditingContact = false;
    this.isPreviousNameEditing = false;
    this.isAliasEditing = false;
    this.selectedIdcard = null;
    this.selectedAliasRow = null;
    this.selectedPreviousNameRow = null;
    this.selectedAddress = null;
    this.selectedContact = null;
    this.selectedGroupPartyRows = null;

    const data = this.getPartiesData();
    if (data) {
      this.resetPartyFormValues(data);
      this.partyForm.disable();
    } else {
      this.partyForm.reset();
    }
  }
  cancelAdd(): void {
    this.resetHandler();
  }

  openAddPartyDialog(section: string): void {
    const dialogRef = this.dialog.open(AddPartyDialogComponent, {
      data: { 'section': section, 'searchQuery': this.searchFormGrp.get('partyId')?.value, isCourtStaff: this.currentScreenType }, disableClose: true,           // Prevents closing on outside click or ESC
      hasBackdrop: true,            // Shows backdrop to block interaction
      backdropClass: 'dialog-backdrop', // Optional: custom styling// Pass the data to the dialog
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.isLoading.set(true);
      if (result) {
        this.partiesData.set(result);
        this.getPartiesData.set(result)
      }
      this.isLoading.set(false);
    });
  }
  fetchIDTypes(): void {
    if (this.idTypes.length === 0) {
      this.isIDTypeLoading = true;
      this.service.getIDTypes().subscribe({
        next: (response) => {
          this.idTypes = response.success;
          this.isIDTypeLoading = false;
        },
        error: (error) => {
          console.error('Error fetching ID Types:', error);
          this.isIDTypeLoading = false;
        },
      });
    }
  }

  fetchContactTypes(): void {
    if (this.contactTypes.length === 0) {
      this.isContactTypeLoading = true;
      this.service.getContactTypes().subscribe({
        next: (response) => {
          this.contactTypes = response.success;
          this.isContactTypeLoading = false;
        },
        error: (error) => {
          console.error('Error fetching Contact Types:', error);
          this.isContactTypeLoading = false;
        },
      });
    }
  }
  fetchCountry(): void {
    if (this.countryList.length === 0) {
      this.isadminTypeLoading = true;
      this.service.getadminTypesCountry().subscribe({
        next: (response) => {
          this.countryList = response.success;
          this.isadminTypeLoading = false;
        },
        error: (error) => {
          console.error('Error fetching Country:', error);
          this.isadminTypeLoading = false;
        },
      });
    }
  }
  fetchState(): void {
    if (this.stateList.length === 0) {
      this.isadminTypeLoading = true;
      this.service.getadminTypesPlace().subscribe({
        next: (response) => {
          this.stateList = response.success;
          this.isadminTypeLoading = false;
        },
        error: (error) => {
          console.error('Error fetching Country:', error);
          this.isadminTypeLoading = false;
        },
      });
    }
  }
  onMobileInput(event: Event): void {
    const input = (event.target as HTMLInputElement).value;
    if (input.length < 11 && this.tooltip) {
      this.tooltip.show();
    } else if (this.tooltip) {
      this.tooltip.hide();
    }
  }


  // Check if mobile number is valid


  // On Email Input
  onContactEmailInput(index: number): void {
    this.contactsList[index].isEdited = true;
  }

  allowOnlyNumbersAndDash(event: KeyboardEvent): void {
    const allowedRegex = /^[0-9\-]$/; // Only numbers and dash allowed
    const key = event.key;
    if (!allowedRegex.test(key)) {
      event.preventDefault();
    }
  }

  // ✅ Handle input change
  onMobileInputNoFormat(index: number): void {
    if (this.contactsList[index]) {
      this.contactsList[index].isEdited = true; // Mark edited
    }
  }

  // ✅ Validate Mobile number (only digits, remove dash, must be 11 digits)
  isValidMobileNumber(value: string): boolean {
    if (!value) return false;
    const digitsOnly = value.replace(/[^0-9]/g, '');
    return digitsOnly.length === 11;
  }


  isValidEmail(value: string | null): boolean {
    if (!value) return false;
    // Simple regex for email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(value);
  }
  removeStaffCode(partiesId: string, courtStaffCode: string): string {
    if (partiesId.startsWith(courtStaffCode)) {
      return partiesId.substring(courtStaffCode.length);
    }
    return partiesId;
  }
  onEmailInput(event: Event): void {
    const input = (event.target as HTMLInputElement).value;
    if (!this.isValidEmail(input) && this.emailTooltip) {
      this.emailTooltip.show();
    } else if (this.emailTooltip) {
      this.emailTooltip.hide();
    }
  }


}
